import styled from 'styled-components';

interface CropImageDivProps {
  loadingState?: string;
  mobileWidth?: number | string;
  width: number | string;
}

export const CropImageDiv = styled.div<CropImageDivProps>`
  width: ${({ width }) => (typeof width === 'string' ? width : `${width}px`)};

  @media (max-width: 480px) {
    width: ${({ mobileWidth }) =>
      mobileWidth
        ? typeof mobileWidth === 'string'
          ? mobileWidth
          : `${mobileWidth}px`
        : 'auto'};
  }
`;
